import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { Button } from 'aimo-ui';
import VehicleSelectDropDown from 'components/park/detail/VehicleSelectDropDown';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RowSpaceBetween } from 'styles/ContainerStyles';
import { Maybe, UsageType } from 'types/generatedSchemaTypes';
import { RootNavProps, RootStackParamList } from 'types/navigation';

interface PermitBottomButtonsProps {
  onPress: () => void;
  isRedeemed: boolean;
  isRedeemable: boolean;
  disabled: boolean;
  loading: boolean;
  showLicensePlate?: boolean;
  usageType?: Maybe<UsageType>;
}

const PermitBottomButtons: React.FC<PermitBottomButtonsProps> = ({
  onPress,
  isRedeemed,
  isRedeemable,
  disabled,
  loading,
  showLicensePlate,
  usageType,
}) => {
  const { t } = useTranslation();
  const { navigate } = useNavigation<RootNavProps>();
  const {
    params: { permitId },
  } = useRoute<RouteProp<RootStackParamList, 'permitRedeem'>>();

  const handleVehiclesSelect = () => {
    navigate('permitVehicles', { permitId });
  };

  return (
    <>
      <RowSpaceBetween>
        {showLicensePlate && (
          <VehicleSelectDropDown
            showInfoIconIfNotSelected={true}
            allowMultipleSelection={true}
            handleVehiclesSelect={handleVehiclesSelect}
          />
        )}
      </RowSpaceBetween>
      {usageType !== 'CUSTOMER' && usageType !== 'SKIDATA' && (
        <Button
          size="l"
          onPress={onPress}
          disabled={disabled}
          loading={loading}
          text={
            !isRedeemable || isRedeemed
              ? t('button.update')
              : t('button.redeem')
          }
          testID="redeem-permit-button"
        />
      )}
    </>
  );
};

export default PermitBottomButtons;
